import styled from 'styled-components'

export const Sumary = styled.span`
  &&& {
    color: #52575c;
  }
`
